import React, { FC } from 'react'
import { InstructionsCard } from 'snippet/instructionsCard'
import gtmIcon from './snippetContainer/wordpress.svg'
import { ActionButton } from 'uiComponents/buttons'
import './wordPressCard.scss'
import { Trans, useTranslation } from 'translations'

type WordPressCardProps = {
    detectSnippet: () => void
}

export const WordPressCard: FC<WordPressCardProps> = ({ detectSnippet }) => {
    const { t } = useTranslation()
    const closedSubHeader = t('snippet.wordPress.closedSubHeader')
    const openedSubHeader = (
        <Trans
            i18nKey="snippet.wordPress.openedSubHeader"
            components={{
                article: (
                    <a
                        href="https://support.convious.com/help/convious-script-installation-with-the-word-press-plug-in"
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
            }}
        />
    )

    return (
        <InstructionsCard
            iconSrc={gtmIcon}
            header={t('snippet.wordPress.header')}
            closedSubHeader={closedSubHeader}
            openedSubHeader={openedSubHeader}
            className="wordpress-card"
        >
            <div className="wordpress-card__instructions">
                <div className="wordpress-card__list">
                    <div className="wordpress-card__list-item">
                        <Trans
                            i18nKey="snippet.wordPress.steps.download"
                            components={{
                                download: (
                                    <a href="https://cdn2.hubspot.net/hubfs/4193864/Convious%20WP%20PlugIn%20-%201.0.0.zip" />
                                ),
                            }}
                        />
                    </div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.logIn')}</div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.addNew')}</div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.upload')}</div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.install')}</div>

                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.activate')}</div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.settings')}</div>
                    <div className="wordpress-card__list-item">
                        <Trans
                            i18nKey="snippet.wordPress.steps.partnerId"
                            components={{
                                partnerId: (
                                    <a
                                        href="https://support.convious.com/help/convious-partner-id"
                                        target="_blank"
                                        rel="noreferrer"
                                    />
                                ),
                            }}
                        />
                    </div>
                    <div className="wordpress-card__list-item">{t('snippet.wordPress.steps.save')}</div>
                </div>
                <div className="wordpress-card__instructions-text">{t('snippet.wordPress.done')}</div>
            </div>
            <ActionButton size="large" style={{ marginTop: '1.5em' }} onClick={detectSnippet}>
                {t('snippet.wordPress.checkNow')}
            </ActionButton>
        </InstructionsCard>
    )
}
